import { render, staticRenderFns } from "./home-partners.vue?vue&type=template&id=07abfd9c&scoped=true"
import script from "./home-partners.vue?vue&type=script&lang=js"
export * from "./home-partners.vue?vue&type=script&lang=js"
import style0 from "./home-partners.vue?vue&type=style&index=0&id=07abfd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abfd9c",
  null
  
)

export default component.exports